import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, of, switchMap } from 'rxjs';
import { AuthTokenService } from './auth-token.service';
import { StudyManagerAuthService } from '../services/study-manager-auth/study-manager-auth.service';

export const apiTokenInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {

  if (!req.url.includes('/api/')) {
    return next(req);
  }

  if (req.url.includes('/api/v1/')) {
    const studyManagerAuthService = inject(StudyManagerAuthService);
    const token = studyManagerAuthService.getCredentials()?.token;

    if (!token) {
      return next(req);
    }
    return next(req.clone({ setHeaders: { Authorization: `Token ${token}` } }));
  }

  const authTokenService = inject(AuthTokenService);

  return authTokenService.getToken().pipe(
    catchError(() => of(null)),
    switchMap(token => {
      if (!token) {
        return next(req);
      }
      return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
    }),
  );
};
